import React from 'react';

//Components.
import LoginForm from '../../form/login-form/LoginForm';

//Depdendencies.
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import "./LoginModal.styles.css";


const LoginModal = ({ modal, setModal }) => {
  const toggle = () => setModal(!modal);

  const closeBtn = () => (
     <button className='close text-danger' onClick={toggle} type='button' style={{border: "none", fontWeight: "bolder"}}>
      <h3>&times;</h3>
     </button>
  )
  
  return (
    <>
      <Modal isOpen={modal} toggle={toggle} fullscreen>
        <ModalHeader toggle={toggle}>
          <span className='text-danger'>LOGIN!!!</span>
        </ModalHeader>
        <ModalBody className='modalBody'>
          <LoginForm toggle={toggle} modal={modal} />
        </ModalBody>
      </Modal>
    </>
  )
}

export default LoginModal